import { MapLayout as Layout } from 'ui-components'

import { error } from '../Error'
import { Footer } from './Footer'
import { Header } from './Header'
import { Main } from './Main'
import { Nav } from './Nav'
import { Onboard } from './Onboard'
import { SideBar } from './SideBar'

import { MapSearch } from '~map-preview/App/Tools/MapSearch'
import { MapToolbar } from '~map-preview/App/Tools/MapToolbar'

import { useInitMapData } from '~map-preview/hooks/useInitMapData'
import { useGetMapById } from '~map-preview/queries/useGetMapById'
import { providers } from '~map-preview/states/provider'
import { MapData } from '~map-preview/types/__generated/gql/graphql'

interface AppProps {
  mapId: string
  map?: MapData
  userId: string
}

export const App = providers(
  error((props: AppProps) => {
    const { mapId, map } = props

    useInitMapData(mapId, map)
    useGetMapById(mapId)

    return (
      <>
        <Layout
          slots={{
            Header,
            Nav,
            MapToolbar,
            MapSearch,
            Main,
            SideBar,
            Footer
          }}
        />

        <Onboard />
      </>
    )
  })
)
